'use client';

import React from 'react';
import styles from './footer.module.scss';
import Image from 'next/image';
import Link from 'next/link';
import assetLoader from '@/utils/asset-loader';

export function Footer() {
    return (
        <footer className={styles.footer}>
            <div className={styles['footer-content']}>
                {/* Logo Section */}
                <div className={styles['logo-and-navigation']}>
                    <div className={styles['logo-section']}>
                        <div className={styles.logo}>
                            <Image
                                src="/ci/images/landing/icons/udemy-logo-white.svg"
                                alt="Udemy"
                                width={96}
                                height={32}
                            />
                        </div>
                    </div>

                    {/* Navigation Links */}
                    <nav className={styles.navigation}>
                        {/* About Section */}
                        <div className={styles['nav-section']}>
                            <h3 className={styles['section-title']}>About</h3>
                            <ul className={styles['link-list']}>
                                <li>
                                    <a href="#" className={styles.link}>
                                        About us
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className={styles.link}>
                                        Careers
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className={styles.link}>
                                        Contact us
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className={styles.link}>
                                        Blog
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className={styles.link}>
                                        Investors
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Discover Udemy Section */}
                        <div className={styles['nav-section']}>
                            <h3 className={styles['section-title']}>Discover Udemy</h3>
                            <ul className={styles['link-list']}>
                                <li>
                                    <a href="#" className={styles.link}>
                                        Get the app
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className={styles.link}>
                                        Teach on Udemy
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className={styles.link}>
                                        Plans and Pricing
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className={styles.link}>
                                        Affiliate
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className={styles.link}>
                                        Help and Support
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Legal & Accessibility Section */}
                        <div className={styles['nav-section']}>
                            <h3 className={styles['section-title']}>Legal & Accessibility</h3>
                            <ul className={styles['link-list']}>
                                <li>
                                    <a href="#" className={styles.link}>
                                        Accessibility statement
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className={styles.link}>
                                        Privacy policy
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className={styles.link}>
                                        Sitemap
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className={styles.link}>
                                        Terms
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>

                {/* Bottom Section */}
                <div className={styles['bottom-section']}>
                    {/* Social Media Icons */}
                    <div className={styles['social-icons']}>
                        <Link
                            href="https://www.instagram.com/udemy/"
                            target="_blank"
                            className={styles['social-button']}
                        >
                            <span
                                className={styles.instagram}
                                style={{
                                    maskImage: `url(${assetLoader({src: '/ci/images/landing/icons/insta.svg'})})`,
                                }}
                            ></span>
                        </Link>
                        <Link
                            href="https://www.facebook.com/udemy/"
                            target="_blank"
                            className={styles['social-button']}
                        >
                            <span
                                className={styles.facebook}
                                style={{
                                    maskImage: `url(${assetLoader({src: '/ci/images/landing/icons/fb.svg'})})`,
                                }}
                            ></span>
                        </Link>
                        <Link
                            href="https://www.linkedin.com/company/udemy/"
                            target="_blank"
                            className={styles['social-button']}
                        >
                            <span
                                className={styles.linkedin}
                                style={{
                                    maskImage: `url(${assetLoader({src: '/ci/images/landing/icons/linkedin.svg'})})`,
                                }}
                            ></span>
                        </Link>
                    </div>

                    {/* Copyright */}
                    <div className={styles.copyright}>
                        <p>© 2025 Udemy, Inc.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
